import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

import { PcsDate } from './pcs-date';

const addPrefix = (num: number): string => (`0${num}`).slice(-2);

/**
 * Converts Date object to number array.
 * @param date Date
 * @returns {Array<number>} Number array
 */
const toLocalDateTimeArrayFromDate = (date: Date): PcsDate => [
  date.getFullYear(),
  date.getMonth() + 1,
  date.getDate(),
  date.getHours(),
  date.getMinutes(),
  date.getSeconds()];

/**
 * The input from the user must be in the following format:
 * yyyy{SEPARATOR}mm{SEPARATOR}dd
 * where SEPARATOR can be one of the following: ., -, /.
 *
 * This function will parse the input into the following format:
 * {yyyy-mm-dd}
 *
 * @param {string} inputValue input value
 * @returns string formatted value
 */
export const parseDateInput = (inputValue: string): string =>
  inputValue.split('.').join('-').split('/').join('-');

export const formatNgbDate = (date: NgbDateStruct): string =>
  `${date.year}-${addPrefix(date.month)}-${addPrefix(date.day)}`;

export const toNgbDate = (date: Date | PcsDate): NgbDateStruct => {
  if (date) {
    let dateToConvert = date;
    if (date instanceof Date) {
      dateToConvert = toLocalDateTimeArrayFromDate(date);
    }

    return {
      year: dateToConvert[0],
      month: dateToConvert[1],
      day: dateToConvert[2]
    };
  }
};

export const isValidDate = (date: Date): boolean => !isNaN(date.getTime());

export const dateFromArray = ([year, monthValue, dayOfMonth, hours = 0, minutes = 0, seconds = 0]: PcsDate): Date =>
  new Date(year, monthValue - 1, dayOfMonth, hours, minutes, seconds);
